<template>
  <x-form
    :disabled="!login.id"
    :prevent-submit="!password || password != confirmPassword || sending"
    :submit-text="_t('Cambia Password')"
    @submit="changePassword"
  >
    <form-group :name="_t('Password')">
      <x-input
        id="anagraficaResetPassword"
        v-model="password"
        type="password"
        minlength="8"
        required
        autocomplete="new-password"
      />
    </form-group>

    <form-group :name="_t('Conferma Password')">
      <x-input
        id="anagraficaConfirmPassword"
        v-model="confirmPassword"
        type="password"
        minlength="8"
        required
        autocomplete="off"
      />
    </form-group>
  </x-form>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { $t as _t } from '@/i18n';
import { useLoginStore } from '@/store/login';
import { Resource } from '@/resources';
import { useAlertStore } from '@/store/alerts';
import { useFunctionRunningState } from '@common/use';

const password = ref('');
const confirmPassword = ref('');
const login = useLoginStore();

const { isRunning: sending, run: changePassword } = useFunctionRunningState(async() => {
  const alertStore = useAlertStore();

  try {
    if (!login.id) {
      return;
    }
    await new Resource('login').put(login.id, {
      password: password.value,
    });
    alertStore.add({ title: _t('Password modificata correttamente.'), type: 'success', toast: true });
  } catch {
    alertStore.add({ title: _t('Errore: password non modificata. Contatta il nostro supporto per maggiori informazioni.'), type: 'danger', toast: true });
  }
  password.value = '';
  confirmPassword.value = '';
}, { preventMultiple: true });
</script>
